import gql from 'graphql-tag'

export const EXPRESS_KEYS = gql`
  query ExpressKeys {
    expressKeys {
      channelName
      traceId
      appKey
      cluster
    }
  }
`
